var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShortSleeveTShirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3B55E6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,117H24c-0.55,0-1-0.45-1-1V49H8c-0.55,0-1-0.45-1-1v-8C7,19.6,23.6,3,44,3c0.55,0,1,0.45,1,1v4 c0,4.19,1.68,8.08,4.74,10.95c3.06,2.86,7.04,4.29,11.26,4.02c7.85-0.51,14-7.32,14-15.52V4c0-0.55,0.45-1,1-1 c20.4,0,37,16.6,37,37v8c0,0.55-0.45,1-1,1H97v67C97,116.55,96.55,117,96,117z M25,115h70V48c0-0.55,0.45-1,1-1h15v-7 c0-18.96-15.16-34.45-34-34.99v2.44c0,9.24-6.97,16.94-15.87,17.51c-4.75,0.31-9.29-1.31-12.75-4.56C44.96,17.2,43,12.68,43,8 V5.01C24.16,5.55,9,21.04,9,40v7h15c0.55,0,1,0.45,1,1V115z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,57H8c-0.55,0-1-0.45-1-1v-8c0-0.55,0.45-1,1-1h16c0.55,0,1,0.45,1,1v8C25,56.55,24.55,57,24,57z M9,55 h14v-6H9V55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112,57H96c-0.55,0-1-0.45-1-1v-8c0-0.55,0.45-1,1-1h16c0.55,0,1,0.45,1,1v8C113,56.55,112.55,57,112,57z  M97,55h14v-6H97V55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,89c-11.58,0-21-9.42-21-21s9.42-21,21-21s21,9.42,21,21S71.58,89,60,89z M60,49c-10.48,0-19,8.52-19,19 c0,10.48,8.52,19,19,19s19-8.52,19-19C79,57.52,70.48,49,60,49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 52,
    cy: 64,
    r: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 68,
    cy: 64,
    r: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,81c-3.86,0-7-3.14-7-7c0-0.55,0.45-1,1-1s1,0.45,1,1c0,2.76,2.24,5,5,5s5-2.24,5-5c0-0.55,0.45-1,1-1 s1,0.45,1,1C67,77.86,63.86,81,60,81z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,25c-9.37,0-17-7.63-17-17V4c0-0.55,0.45-1,1-1s1,0.45,1,1c0,3.79,6.87,7,15,7s15-3.21,15-7 c0-0.55,0.45-1,1-1s1,0.45,1,1v4C77,17.37,69.37,25,60,25z M45,8.3C45.17,16.44,51.83,23,60,23s14.83-6.56,15-14.7 c-2.84,2.82-8.43,4.7-15,4.7S47.84,11.12,45,8.3z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortSleeveTShirt);
export default __webpack_public_path__ + "static/media/shortSleeveTShirt.b934e930db5818957e8d18852f37e3c0.svg";
export { ForwardRef as ReactComponent };